import { DisplayText, Layout, Page, TopBar } from '@shopify/polaris';
import React from 'react';

function SignupPage(props) {
  return (
    <Page fullWidth>
      <div className="Pubilc">
        <TopBar />
      </div>
      <Layout>
        <Layout.Section>
          <div className="fx col jctr actr">
            <DisplayText size="large">Get start to MSP platform</DisplayText>
            <DisplayText size="small">
              An application helps you to improve your productvity.
            </DisplayText>
            <img
              className="BannerImage pt25"
              src={props.conf.imageRoot + 'svg/click_here.svg'}
              alt="Kiwi standing on oval"
            ></img>
          </div>
        </Layout.Section>

        <Layout.Section secondary>{props.container}</Layout.Section>
      </Layout>
    </Page>
  );
}

export default SignupPage;
